(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bpc-couple-pillow"] && !Shopify.designMode) return;
  try {
    
function initBpcPillow(root){
if(root.dataset.ready)return;root.dataset.ready='true';
root.querySelectorAll('[data-bpc-image]').forEach(button=>button.addEventListener('click',()=>{
const img=root.querySelector('.bpc-main-image img');img.removeAttribute('srcset');img.src=button.dataset.bpcImage;
root.querySelectorAll('[data-bpc-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
}));
const select=root.querySelector('select[name="id"]');
if(select)select.addEventListener('change',()=>{
const option=select.selectedOptions[0];root.querySelectorAll('[data-bpc-price]').forEach(el=>el.textContent=option.dataset.price);
root.querySelectorAll('[data-bpc-add]').forEach(el=>{el.disabled=option.dataset.available!=='true';el.textContent=el.disabled?el.dataset.sold:el.dataset.add;});
const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
});
}
document.querySelectorAll('.bpc-pillow').forEach(initBpcPillow);
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.bpc-pillow').forEach(initBpcPillow));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bpc-pillow-home"] && !Shopify.designMode) return;
  try {
    
function initHugStore(){
  document.querySelectorAll('.hug-store').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';

    const wireGallery=(buttons,mainSelector,srcKey,altKey)=>{
      if(buttons.length<2)return;
      const image=root.querySelector(mainSelector+' img');
      if(!image)return;
      let index=0;
      let timer=null;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

      const stop=()=>{
        if(timer){clearInterval(timer);timer=null;}
      };
      const show=(button)=>{
        if(!button)return;
        image.removeAttribute('srcset');
        image.src=button.dataset[srcKey];
        if(button.dataset[altKey])image.alt=button.dataset[altKey];
        buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        index=buttons.indexOf(button);
      };
      const start=()=>{
        stop();
        if(reduced)return;
        timer=setInterval(()=>{
          show(buttons[(index+1)%buttons.length]);
        },4000);
      };

      buttons.forEach(button=>button.addEventListener('click',()=>{
        show(button);
        start();
      }));

      const hoverTarget=mainSelector==='[data-hero-main]'
        ? root.querySelector('.hug-hero-stage')
        : root.querySelector('.hug-offer');
      if(hoverTarget){
        hoverTarget.addEventListener('mouseenter',stop);
        hoverTarget.addEventListener('mouseleave',start);
        hoverTarget.addEventListener('focusin',stop);
        hoverTarget.addEventListener('focusout',()=>{
          if(!hoverTarget.contains(document.activeElement))start();
        });
      }

      show(buttons[0]);
      start();
    };

    wireGallery(
      Array.from(root.querySelectorAll('[data-hero-src]')),
      '[data-hero-main]',
      'heroSrc',
      'heroAlt'
    );
    wireGallery(
      Array.from(root.querySelectorAll('[data-pillow-src]')),
      '[data-pillow-main]',
      'pillowSrc',
      'pillowAlt'
    );

    root.querySelectorAll('[data-hug-src]').forEach(button=>button.addEventListener('click',()=>{
      const img=root.querySelector('[data-hug-viewer] img');
      if(!img)return;
      img.removeAttribute('srcset');
      img.src=button.dataset.hugSrc;
      root.querySelectorAll('[data-hug-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));

    if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&matchMedia('(hover: hover)').matches){
      root.querySelectorAll('.hug-tilt').forEach(card=>{
        card.addEventListener('pointermove',e=>{
          const r=card.getBoundingClientRect();
          const x=(e.clientX-r.left)/r.width-.5;
          const y=(e.clientY-r.top)/r.height-.5;
          card.style.transform='rotateX('+(-y*8)+'deg) rotateY('+(x*8)+'deg)';
        });
        card.addEventListener('pointerleave',()=>card.style.transform='');
      });
    }

    /* Bundle selector behavior */
    const stickyPrice=root.querySelector('[data-sticky-bundle-price]');
    root.querySelectorAll('[data-bundle-choice]').forEach(choice=>{
      const update=()=>{
        const form=choice.closest('form');
        if(!form)return;
        const variant=form.querySelector('[data-bundle-variant-input]');
        const quantity=form.querySelector('[data-bundle-quantity-input]');
        if(variant)variant.value=choice.dataset.bundleVariant;
        if(quantity)quantity.value=choice.dataset.bundleQuantity || '1';
        if(stickyPrice)stickyPrice.textContent=(choice.dataset.bundlePrice || 'AU$49.00')+' ↗';
      };
      choice.addEventListener('change',update);
      if(choice.checked)update();
    });
  });
}
initHugStore();
document.addEventListener('shopify:section:load',initHugStore);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bpc-white-willow"] && !Shopify.designMode) return;
  try {
    
function initBpcPillow(root){
if(root.dataset.ready)return;root.dataset.ready='true';
root.querySelectorAll('[data-bpc-image]').forEach(button=>button.addEventListener('click',()=>{
const img=root.querySelector('.bpc-main-image img');img.removeAttribute('srcset');img.src=button.dataset.bpcImage;
root.querySelectorAll('[data-bpc-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
}));
const select=root.querySelector('select[name="id"]');
if(select)select.addEventListener('change',()=>{
const option=select.selectedOptions[0];root.querySelectorAll('[data-bpc-price]').forEach(el=>el.textContent=option.dataset.price);
root.querySelectorAll('[data-bpc-add]').forEach(el=>{el.disabled=option.dataset.available!=='true';el.textContent=el.disabled?el.dataset.sold:el.dataset.add;});
const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
});
}
document.querySelectorAll('.bpc-pillow').forEach(initBpcPillow);
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.bpc-pillow').forEach(initBpcPillow));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
